import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  Box,
  Button,
  Flex,
  IconButton,
  Input,
  Stack,
  Heading,
  AccordionPanel,
} from "@chakra-ui/react";
import React from "react";
import { BsSearch } from "react-icons/bs";
import FilterSection from "../components/findWork/FilterSection";
import JobCard from "../components/findWork/JobCard";
import CommonContainer from "../components/shared/CommonContainer";

export default function FindWorkPage() {
  return (
    <Stack bgColor="#f7f7f7">

    <CommonContainer >
      <Flex
        border="1px solid gray"
        borderRadius={10}
        overflow="hidden"
        my={{ base: 8, md: 16 }}
        bg="white"
      >
        <Input placeholder="Search for job" w="full" border="0px" />
        <IconButton bg="brand.500" borderRadius={0} color="white" px={4}>
          <BsSearch />
        </IconButton>
      </Flex>
      <Flex gap={10} flexDir={{ base: "column", xl: "row" }}>
        <Accordion display={{ base: "block", xl: "none" }} allowToggle >
          <AccordionItem border={"1px"} borderColor="inherit" borderRadius={10}>
            <AccordionButton
              background="white"
              justifyContent={"space-between"}
              borderRadius={10}
              _hover={{ bg: "white" }}
            >
              <Box as="span">
                <Heading color="gray.500" fontWeight={500} fontSize="22px">
                  Filter By
                </Heading>
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel bg="white">
              <FilterSection />
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
        <Box display={{ base: "none", xl: "block" }} width={"25%"}>
          <FilterSection />
        </Box>
        <Stack
          borderRadius={10}
          overflow="hidden"
          w="full"
          border="1px solid #c5c5c5"
          mb={10}
          bg="white"
        >
          <Box
            color="brand.500"
            bg="#eee"
            borderBottom={"1px solid @c5c5c5"}
            px={10}
            py={6}
            fontWeight="semibold"
          >
            Best Job Opportunities
          </Box>
          {jobsData.map((item, index) => {
            return (
              <JobCard
                title={item.title}
                description={item.description}
                spent={item.spend}
                reviews={item.reviews}
                paymentVerified={item.paymentVerified}
                location={item.location}
                verified={item.verified}
                key={index}
                last={jobsData.length - 1 === index}
              />
            );
          })}
          <Flex justifyContent={"center"} p={10}>
            <Button
              variant="outline"
              color="brand.500"
              px={10}
              borderRadius={20}
            >
              Load More Jobs
            </Button>
          </Flex>
        </Stack>
      </Flex>
    </CommonContainer>
    </Stack>
  );
}
const jobsData = [
  {
    title: "Skilled GRAPHIC DESIGNERS for on-going projects",
    description: (
      <Box>
        We are looking for a skilled designers to help with ongoing projects we
        have so many.
        <br />
        Help us with:
        <br />
        * Social Media Memes
        <br />
        * Presentation Designs
        <br />
        * Quick Edits
        <br />
      </Box>
    ),
    verified: true,
    paymentVerified: true,
    spend: "1k",
    reviews: true,
    location: "United Kingdom",
  },
  {
    title: "Skilled Graphic Designers for on going projects",
    description: (
      <Box>
        We are looking for a skilled designers to help with ongoing projects we
        have so many.
        <br />
        Help us with:
        <br />
        * Social Media Memes
        <br />
        * Presentation Designs
        <br />
        * Quick Edits
        <br />
      </Box>
    ),
    verified: false,
    paymentVerified: false,
    spend: "0",
    reviews: false,
    location: "United States",
  },
  {
    title: "Skilled Graphic Designers for on going projects",
    description: (
      <Box>
        We are looking for a skilled designers to help with ongoing projects we
        have so many.
        <br />
        Help us with:
        <br />
        * Social Media Memes
        <br />
        * Presentation Designs
        <br />
        * Quick Edits
        <br />
      </Box>
    ),
    verified: false,
    paymentVerified: false,
    spend: "0",
    reviews: false,
    location: "United States",
  },
  {
    title: "Skilled Graphic Designers for on going projects",
    description: (
      <Box>
        We are looking for a skilled designers to help with ongoing projects we
        have so many.
        <br />
        Help us with:
        <br />
        * Social Media Memes
        <br />
        * Presentation Designs
        <br />
        * Quick Edits
        <br />
      </Box>
    ),
    verified: false,
    paymentVerified: false,
    spend: "0",
    reviews: false,
    location: "United States",
  },
  {
    title: "Skilled Graphic Designers for on going projects",
    description: (
      <Box>
        We are looking for a skilled designers to help with ongoing projects we
        have so many.
        <br />
        Help us with:
        <br />
        * Social Media Memes
        <br />
        * Presentation Designs
        <br />
        * Quick Edits
        <br />
      </Box>
    ),
    verified: false,
    paymentVerified: false,
    spend: "0",
    reviews: false,
    location: "United States",
  },
  {
    title: "Skilled Graphic Designers for on going projects",
    description: (
      <Box>
        We are looking for a skilled designers to help with ongoing projects we
        have so many.
        <br />
        Help us with:
        <br />
        * Social Media Memes
        <br />
        * Presentation Designs
        <br />
        * Quick Edits
        <br />
      </Box>
    ),
    verified: false,
    paymentVerified: false,
    spend: "0",
    reviews: false,
    location: "United States",
  },
  {
    title: "Skilled Graphic Designers for on going projects",
    description: (
      <Box>
        We are looking for a skilled designers to help with ongoing projects we
        have so many.
        <br />
        Help us with:
        <br />
        * Social Media Memes
        <br />
        * Presentation Designs
        <br />
        * Quick Edits
        <br />
      </Box>
    ),
    verified: false,
    paymentVerified: false,
    spend: "0",
    reviews: false,
    location: "United States",
  },
];
